import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import {Router} from "@angular/router"

import { MenuController } from '@ionic/angular';

import { LocalContentService } from '../../services/local-content/local-content.service'

@Component({
  selector: 'app-content-menu',
  templateUrl: './content-menu.component.html',
  styleUrls: ['./content-menu.component.scss'],
})
export class ContentMenuComponent implements OnInit {

  @Input() basePage: String="0_0_0";
  @Input() alwaysNav=false;

  constructor(private localContentService: LocalContentService,
              private router: Router,private menuCtrl: MenuController) { }

  public content:any={};
  public list:any[]=[];

  ngOnInit() {
    this.localContentService.getStaticContent().subscribe((data)=>{
      this.content=data;
      if (!this.content.pages) return; //don;t have content yet
      //make a flat array
      let list=[];
      const addPage=(pn,above,level) => {
        let p=this.content.pages[pn]
        if (!p) return; //no such item
        let nv={
          title: (p.content&&p.content.title)?p.content.title:pn+" [No details]",
          icon: p.icon,
          parent: above,
          expanded: !level,
          level: level,
          isLeaf: !p.subpages,
          pageRef: pn,
        };
        if (level)
          list.push(nv);
        if (p.subpages)
          p.subpages.split(' ').forEach((n)=>addPage(n,nv,level+1))
      }
      addPage(this.basePage,null,0);
      this.list=list;
    })


    this.localContentService.pageDisplayRequest.subscribe((pageRef)=>{
       this.menuCtrl.open();
       //find item and expand it;
       let item=this.list.find(li=>(li.pageRef==pageRef));
       this.expand(item,true);
    });

  }

  expand(item,force:null|boolean=null) //toggle by default - can be forced to true /false
  {
    if (this.alwaysNav)
      this.router.navigate(['/content',item.pageRef])
    if (force===null)
      item.expanded=!item.expanded;
    else
      item.expanded=force;
    //go through the list and reduce anyone who is not a ancestor of this page
    if (item.expanded) //close every item that is not part of this expansion
      this.list.forEach(i=>{
         if (!this.isAbove(i,item)) i.expanded=false;
      })
  }

  isAbove(item,base) {
    if (item==base) return true; //we are 'above ourselves' in this sense
    if (!base.parent) return false; //must be a top level item nothing is above it
    if (base.parent==item) return true; //the item is directly above this one
    return this.isAbove(item,base.parent);
  }

  canShow(item) {
    if (!item.parent) return true;
    if (!item.parent.expanded) return false;
    return this.canShow(item.parent);
  }

}
